import type { ChartConfiguration, DoughnutControllerChartOptions } from 'chart.js';
import {
  ArcElement,
  BarController,
  BarElement,
  CategoryScale,
  Chart,
  DoughnutController,
  Filler,
  LinearScale,
  LineController,
  LineElement,
  PointElement,
  Tooltip,
} from 'chart.js';
import ChartDeferred from 'chartjs-plugin-deferred';

export type ChartType = Chart;

export class ChartJsService {
  chart: Chart;
  config: ChartConfiguration;

  constructor(container: HTMLCanvasElement, config: ChartConfiguration) {
    switch (config.type) {
      case 'doughnut':
        Chart.register(ArcElement, DoughnutController);
        break;
      case 'bar':
      case 'line':
        Chart.register(
          BarController,
          BarElement,
          CategoryScale,
          Filler,
          LineController,
          LineElement,
          LinearScale,
          PointElement,
          Tooltip,
        );
        break;
      default:
        break;
    }

    Chart.register(ChartDeferred);

    this.config = { ...config };
    // Defer the chart animation
    this.config.options.plugins['deferred'] = {
      yOffset: '50%', // until 50% of the canvas height are inside the viewport
      delay: 250, // delay of 250ms after the canvas is considered inside the viewport
    };
    this.chart = new Chart(container, this.config);
  }

  update(config?: ChartConfiguration) {
    if (!this.chart) return;

    if (config) {
      this.config = { ...config };
    }
    this.chart.update();
  }

  updateDonutChartCutout(cutout: number | string) {
    if (this.config.type !== 'doughnut') return;

    (this.config.options as Partial<DoughnutControllerChartOptions>).cutout = cutout;
    this.chart.update('resize');
  }

  getConfig() {
    return this.chart.config;
  }

  destroy() {
    if (!this.chart) return;
    this.chart.destroy();
  }
}
